// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const H3OutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 640 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M48 88c0-13.3-10.7-24-24-24S0 74.7 0 88v336c0 13.3 10.7 24 24 24s24-10.7 24-24V272h224v152c0 13.3 10.7 24 24 24s24-10.7 24-24V88c0-13.3-10.7-24-24-24s-24 10.7-24 24v136H48V88zm352-24c-13.3 0-24 10.7-24 24s10.7 24 24 24h142.1L423 231a24.03 24.03 0 0017 41h88c35.3 0 64 28.7 64 64s-28.7 64-64 64h-72.6c-15.6 0-29-11.3-31.6-26.7l-.2-1.2c-2.2-13.1-14.5-21.9-27.6-19.7s-21.9 14.5-19.7 27.6l.2 1.2a79.9 79.9 0 0078.9 66.8H528c61.9 0 112-50.1 112-112s-50.1-112-112-112h-30.1L617 105a24.03 24.03 0 00-17-41H400z"}}]},"name":"h3","theme":"outlined"};

const H3Outlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={H3OutlinedSvg} />;
  H3Outlined.displayName = 'H3Outlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(H3Outlined);
